import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import { Card, CardContent, Divider, Grid, Typography } from '@material-ui/core';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';

import { PostState } from 'types/app';
import { IPostRenderProps } from 'features/posting';
import { PhotoVideoUpload, UserAvatar } from 'components';
import { useCurrentUser } from 'hooks';

interface IProps extends WithStyles<typeof styles> {
  toggleState: IPostRenderProps['toggleState'];
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(3),
    },
    contentFirst: {
      paddingTop: 12,
    },
    content: {
      '&:last-child': {
        paddingBottom: theme.spacing(1),
      },
    },
    divider: {
      marginBottom: theme.spacing(1),
    },
  });

const CreatePostPlaceholder: FC<IProps> = props => {
  const { classes, toggleState } = props;
  const currentUser = useCurrentUser();

  return (
    <Card className={classes.root}>
      <CardContent className={classes.contentFirst}>
        <Grid container alignItems="center" spacing={2} onClick={() => toggleState(PostState.Edit)}>
          <Grid item>
            <UserAvatar size={40} user={currentUser} />
          </Grid>
          <Grid item xs>
            <Typography variant="subtitle2">
              <Trans i18nKey="posting:prompt" />
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <Divider className={classes.divider} />
      <CardContent className={classes.content}>
        <Grid container>
          <Grid item>
            <PhotoVideoUpload onSave={() => toggleState(PostState.Edit)} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(CreatePostPlaceholder);
